// src/services/auth.js
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { auth } from '../config/firebase';

// פונקציית התחברות
export const loginUser = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return {
      user: userCredential.user,
      success: true
    };
  } catch (error) {
    return {
      error: getErrorMessage(error.code),
      success: false
    };
  }
};

// פונקציית התנתקות
export const logoutUser = async () => {
  try {
    await signOut(auth);
    return { success: true };
  } catch (error) {
    return {
      error: getErrorMessage(error.code),
      success: false
    };
  }
};

// פונקציה להמרת קודי שגיאה להודעות בעברית
const getErrorMessage = (errorCode) => {
  switch (errorCode) {
    case 'auth/user-not-found':
      return 'משתמש לא נמצא';
    case 'auth/wrong-password':
      return 'סיסמה שגויה';
    case 'auth/invalid-email':
      return 'כתובת אימייל לא תקינה';
    case 'auth/user-disabled':
      return 'המשתמש חסום';
    case 'auth/email-already-in-use':
      return 'כתובת האימייל כבר בשימוש';
    case 'auth/operation-not-allowed':
      return 'פעולה לא מורשית';
    case 'auth/weak-password':
      return 'סיסמה חלשה מדי';
    default:
      return 'אירעה שגיאה, אנא נסה שוב';
  }
};